export enum PurchaseOrderItemStatus {
  EXPECTED = 'EXPECTED',
  RECEIVED = 'RECEIVED',
  DAMAGED = 'DAMAGED',
  CANCELLED = 'CANCELLED',
  PARTIALLY_RECEIVED = 'PARTIALLY_RECEIVED'
}
